import { TDistinctors, TKeysMaker } from '@apia/dom-store';
import { TState } from './types';

export const makeCellKey = (distinctions: {
  columnIndex: number;
  rowIndex: number;
}) => `${distinctions.columnIndex}__${distinctions.rowIndex}`;

export const keysMakers: TKeysMaker<TState, TDistinctors<TState>> = {
  cell: makeCellKey,
  grid: () => 'grid',
};
